export function DropdownOpenPlugin() {
  const tomSelect = this

  tomSelect.hook("after", "setup", () => {
    tomSelect.focus_node.addEventListener("click", toggleDropdown)
    tomSelect.focus_node.addEventListener("keydown", onKeydown)

    tomSelect.focus_node.addEventListener("mousedown", (e) => {
      if (document.activeElement !== tomSelect.control_input) {
        document.activeElement.blur()
      }
    }, true)
  })

  // The default click handler relies on focus and blur to open the dropdown.
  // Since we disabled open on focus, we want to avoid the control receiving focus
  // before the dropdown opens. This would cause a brief flash of the focused state.
  // - Matt, Stephen, Fri Dec 12 2025
  tomSelect.hook("instead", "onClick", () => {})

  function toggleDropdown() {
    if (tomSelect.isOpen) {
      tomSelect.close()
    } else {
      tomSelect.open()
    }
  }

  const openKeys = ["ArrowDown", "ArrowUp"]

  function onKeydown(e) {
    const isCharacter = e.key.length === 1
    if (openKeys.includes(e.key) || isCharacter) {
      tomSelect.open()
    }
  }
}
